import { Component, ElementRef, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-question-number',
  templateUrl: './question-number.component.html',
  styleUrls: ['./question-number.component.less']
})
export class QuestionNumberComponent implements OnInit, OnChanges {
  @Input() value: number = 0;

  constructor(private elementRef: ElementRef) { }

  ngOnChanges(changes: SimpleChanges): void {
    this.update();
  }

  ngOnInit(): void {

  }
  update() {
    if (this.elementRef) {
      this.elementRef.nativeElement.querySelectorAll('g[data-name="questionLabels"] > g').forEach((el: SVGGElement) => {
        el.classList.remove('selected');
      });
      this.elementRef.nativeElement.querySelector('g[data-name="q' + this.value + '"]')?.classList.add('selected');
    }
  }

}
